import { forwardRef, type InputHTMLAttributes } from 'react'

interface PropTypes extends InputHTMLAttributes<HTMLInputElement> {}

const PanelCheckbox = forwardRef<HTMLInputElement, PropTypes>(function Checkbox ({ name, children, ...rest }, ref) {
  return (
    <div className="flex gap-2 items-center text-xs leading-3 text-gray-600">
      <input
        id={name}
        ref={ref}
        name={name}
        type="checkbox"
        className="appearance-none p-0 inline-block align-middle bg-origin-border select-none shrink-0 h-4 w-4 bg-white border border-gray-400 rounded-[4px] transition-all outline-none bg-no-repeat bg-center bg-[length:50%] checked:bg-primary-800
        checked:bg-[url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%209%207%22%3E%3Cpath%20fill%3D%22white%22%20fill-rule%3D%22evenodd%22%20d%3D%22M.023%203.563%203.045%206.77l5.524-5.7L7.605.055l-4.546%204.69L1%202.555.023%203.563Z%22%20clip-rule%3D%22evenodd%22%20%2F%3E%3C%2Fsvg%3E)]"
        {...rest}
      />
      <label
        htmlFor={name}
        className="cursor-pointer"
      >
        {children}
      </label>
    </div>
  )
})

export default PanelCheckbox
